export default {
  methods: {
    calHASBLED() {
      var score = 0;
      var risk = ['1.13%', '1.02%', '1.88%', '3.74%', '8.70%', '12.5%', '&gt;12.5%', '&gt;12.5%', '&gt;12.5%', '&gt;12.5%', '&gt;12.5%'];
      var a = document.HASBLEDForm.elements;

      for (var i = 9; i--;) {
        if (a[i].checked) {
          score += 1;
        }
      }

      document.getElementById('HASBLEDscore').innerHTML = score;
      document.getElementById('HASBLEDrisk').innerHTML = risk[score];
    }

  },
  id: 'd2c9285e95',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=HASBLED><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>HAS-BLED</div></div></div><div class=page-content><form name=HASBLEDForm><div class="list simple-list"><ul><li><span>Hypertension</span> <label class="toggle toggle-init color-green"><input type=checkbox name=H1 @change=calHASBLED()> <span class=toggle-icon></span></label></li><li><span>Abnormal liver function</span> <label class="toggle toggle-init color-green"><input type=checkbox name=H2 @change=calHASBLED()> <span class=toggle-icon></span></label></li><li><span>Abnormal renal function</span> <label class="toggle toggle-init color-green"><input type=checkbox name=H3 @change=calHASBLED()> <span class=toggle-icon></span></label></li><li><span>Stroke</span> <label class="toggle toggle-init color-green"><input type=checkbox name=H4 @change=calHASBLED()> <span class=toggle-icon></span></label></li><li><span>Bleeding (non-stroke)</span> <label class="toggle toggle-init color-green"><input type=checkbox name=H5 @change=calHASBLED()> <span class=toggle-icon></span></label></li><li><span>Labile INRs</span> <label class="toggle toggle-init color-green"><input type=checkbox name=H6 @change=calHASBLED()> <span class=toggle-icon></span></label></li><li><span>Elderly (Age &gt;65)</span> <label class="toggle toggle-init color-green"><input type=checkbox name=H7 @change=calHASBLED()> <span class=toggle-icon></span></label></li><li><span>Drugs (NSAIDs, antiplatelet)</span> <label class="toggle toggle-init color-green"><input type=checkbox name=H8 @change=calHASBLED()> <span class=toggle-icon></span></label></li><li><span>Alcohol (excessive)</span> <label class="toggle toggle-init color-green"><input type=checkbox name=H9 @change=calHASBLED()> <span class=toggle-icon></span></label></li></ul></div><div class="list simple-list"><ul><li><span>HAS-BLED score:</span><div class=float-right><b><span id=HASBLEDscore>0</span></b></div></li><li><span>Adjusted bleeding rate (% year):</span><div class=float-right><span id=HASBLEDrisk>0%</span></div></li></ul></div><div class=block-footer>Scores &gt;5 were too rare to determine risk, but are likely &gt;12.5%</div></form></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};